module.exports = __webpack_public_path__ + "images/application/i-checkmark-orange-5ae0a08e.svg";